module.exports = __webpack_public_path__ + "img/takeaway.c5352908.png";